import { FunctionComponent } from 'react';
import Footer from '../shared/footer/footer';
import TopMenu from '../shared/top-menu/top-menu';
import './PageNotFound.scss';
import { Link } from 'react-router-dom';
import Contact from '../contact/contact';

export type Props = {};

const PageNotFound: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <div className="page page-not-found">
      <TopMenu selected={undefined}></TopMenu>
      <div className="page-content bg-top5">
        <div className="inner-content">
          <div>
            <h1>404 Fehler: Oops! Dieser Datenpunkt fehlen in unserer Analyse.</h1>
            Aber wir haben einige Statistik-Witze gefunden
          </div>
        </div>
      </div>

      <div className="page-content bg-1">
        <div className="inner-content">
          <p style={{ fontSize: '1.25rem', marginBottom: '2rem' }}>
            Hier gehts{' '}
            <Link
              to="/"
              className="mt-6 px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-700 transition"
            >
              Startseite
            </Link>
          </p>
          <h2>
            Damit Du jetzt aber nicht ganz erfolglos diese Seite gefunden hast, haben wir ein paar
            Witze vorbereitet.
          </h2>
          <h3>1. Der Monte-Carlo-Witz</h3>
          Ein Statistiker fährt nach Las Vegas.
          <br />
          Ein Freund fragt: <i>„Hast du eine Strategie?“</i>
          <br />
          Der Statistiker: <i>„Ja, ich nutze die Monte-Carlo-Methode!“</i>
          <br />
          Freund: <i>„Oh, interessant! Also Simulationen und Wahrscheinlichkeiten?“</i> <br />
          Der Statistiker:{' '}
          <i>
            „Nein, ich setze einfach mein gesamtes Geld auf eine Zahl. Wenn ich verliere, tue ich
            so, als wäre es nie passiert.“
          </i>
          <h3>2. Der beste Weg, Millionär zu werden</h3>
          Wie wird ein Statistiker Millionär?
          <br />
          Ganz einfach: Er startet als Milliardär und fängt an, Prognosen zu machen.
          <h3>3. Der Statistiker und das Flugzeug</h3>
          Ein Statistiker fliegt oft beruflich und nimmt immer eine Bombe im Koffer mit.
          <br />
          Ein Kollege fragt ihn: <i>„Bist du verrückt?!“</i>
          <br />
          Der Statistiker erklärt:{' '}
          <i>
            „Ganz einfach! Die Wahrscheinlichkeit, dass eine Bombe im Flugzeug ist, ist extrem
            gering. Aber die Wahrscheinlichkeit, dass zwei Bomben an Bord sind, ist nahezu null.
            Also bin ich sicher!“
          </i>
          <div style={{ marginTop: '5rem' }}>
            <h3>Kennst Du einen anderen guten Statistik-Witz?</h3>Dann schick uns eine Nachricht:{' '}
            <a
              href="/contact"
              style={{
                border: '2px solid #dc143c',
                padding: '0.25rem 1rem',
                borderRadius: '2.5rem',
              }}
            >
              Zum Kontaktformular
            </a>
            <br />
          </div>
        </div>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default PageNotFound;
